import { Icon } from '@material-ui/core'
import React from 'react'
import { InputProps } from '../Interfaces/Interfaces'
import PrimaryTheme from '../Themes/Primary'

export default function Input(props: InputProps) {
  return (
    <div className="form-group position-relative">
      {props.isInput && <input
        type={props.type}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        autoComplete="off"
        aria-autocomplete="none"
        id={props.id}
        size={props.size}
        maxLength={props.maxLength}
        onClick={props.onClick}
        disabled={props.disabled}
        className={props.className}
        inputMode={props.inputMode}
        required={props.required}
        autoFocus={props.autoFocus}
        min={props.min}
        style={{ ...styles.input, ...props.style, }} />
      }

      {!props.isInput && <textarea
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        autoComplete={props.autoComplete}
        id={props.id}
        onClick={props.onClick}
        disabled={props.disabled}
        required={props.required}
        className={props.className}
        style={{ ...styles.input, ...props.style, }} />
      }

      <div style={{
        position: 'absolute',
        // top: 15,
        right: 15,
        bottom: -20
      }}>
        {props.valid === false && props.showIcon === true && (
          <React.Fragment>
            <div className="row m-0 justify-content-center align-items-center">
              <span style={{
                marginRight: 5,
                color: PrimaryTheme.danger,
                fontFamily: PrimaryTheme.fonts?.RubikLight,
                fontSize: 14
              }}>{props.errorText}</span>
            </div>
          </React.Fragment>
        )}
      </div>
      <div style={{
        position: 'absolute',
        top: '30%',
        right: 15,
      }}>
        {props.valid === true && props.showIcon === true && <svg width="1.3em" height="1.3em" viewBox="0 0 16 16" className="bi bi-check2-circle" fill={PrimaryTheme.success} xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
          <path fillRule="evenodd" d="M8 2.5A5.5 5.5 0 1 0 13.5 8a.5.5 0 0 1 1 0 6.5 6.5 0 1 1-3.25-5.63.5.5 0 1 1-.5.865A5.472 5.472 0 0 0 8 2.5z" />
        </svg>}

        {props.valid === false && !props.isPassword && props.showIcon === true && (
          <React.Fragment>
            <div className="row m-0 justify-content-center align-items-center">
              <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-exclamation-circle-fill" fill={PrimaryTheme.danger} xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
              </svg>
            </div>
          </React.Fragment>
        )}

        {props.isPassword === true && props.showIcon === true && (
          <React.Fragment>
            <Icon className="pointer" onClick={props.onIconClick}>{props.visibilityIcon}</Icon>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}


const styles = {
  input: {
    width: '100%',
    borderRadius: 25,
    border: '1px solid white',
    padding: '.85rem',
  }
}